import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { IEquatable } from "../../../../../Common/ModelPath/IEquatable";

export enum CalculationTargetAttribute {
    Value,
    Validation,
}

export class CalculationTarget implements IEquatable<CalculationTarget> {
    public readonly modelPath: AbsoluteModelPath;
    public readonly targetAttribute: CalculationTargetAttribute;

    public constructor(modelPath: AbsoluteModelPath, targetAttribute: CalculationTargetAttribute) {
        this.modelPath = modelPath;
        this.targetAttribute = targetAttribute;
    }

    public isEquals(target: CalculationTarget): boolean {
        return this.modelPath.isEquals(target.modelPath) && this.targetAttribute === target.targetAttribute;
    }

    public toString(): string {
        const targetAttributeAsString =
            this.targetAttribute === CalculationTargetAttribute.Validation ? "Validation" : "Value";
        return `${this.modelPath}:${targetAttributeAsString}`;
    }

    public getHash(): number {
        return this.modelPath.getHash() ^ this.targetAttribute;
    }
}
